import http from '@root/utils/axios/admin';

let state = {
    CardRechargesList: [],
    CardRecharge: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchCardRechargesList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('/api/recharge-cards', { params: filter }).then((response) => {
                commit('setCardRecharges', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    fetchCardRechargesGroupedByList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('/api/recharge-cards-grouped-by', { params: filter }).then((response) => {
                commit('setCardRecharges', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteCardRecharge({ commit }, id) {
        return http.delete('/api/recharge-cards/' + id);
    },

    fetchCardRecharge({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('/api/recharge-cards/' + id).then((response) => {
                commit('setCardRecharge', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    CreateCardRecharge({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/recharge-cards', data).then((response) => {
                commit('setCardRecharge', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setCardRechargeError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    CreateCardRechargeAsFile({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/recharge-cards-file', data).then((response) => {
                commit('setCardRecharge', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setCardRechargeError', error.response.data);
                }
                reject(error.response);
            })
        });
    },


    updateCardRecharge({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/recharge-cards/' + data.id, data).then((response) => {
                commit('setCardRecharge', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setCardRechargeError', error.response.data);
                }
                reject(error.response);
            })
        });
    },

    requestCardRecharge({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/request-recharge-card', data).then((response) => {
                commit('setCardRecharge', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setCardRechargeError', error.response.data);
                }
                reject(error.response);
            })
        });

    },
    cardCenterReceive({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/group-recharge-card-center-receive', data).then((response) => {
                commit('setCardRecharge', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setCardRechargeError', error.response.data);
                }
                reject(error.response);
            })
        });

    },
    rechargeCardSell({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/recharge-card-sell', data).then((response) => {
                commit('setCardRecharge', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setCardRechargeError', error.response.data);
                }
                reject(error.response);
            })
        });

    },


}


let mutations = {
    setCardRecharges(state, data) {
        state.CardRechargesList = data;
    },
    setCardRecharge(state, data) {
        state.CardRecharge.data = data;
    },
    setCardRechargeError(state, error) {

        state.CardRecharge.error = error.errors;
    },
    cleanCardRechargeError(state, error) {
        state.CardRecharge.error = {};
    },
    cleanCardRechargeList(state, data) {
        state.CardRechargesList = [];
    },

}

export default {
    state,
    actions,
    mutations
}